export default __webpack_public_path__ + "static/media/27.5f627ad7.jpg";